const NoDialog = () => (
  <></>
)

export default NoDialog
